import React, { useEffect, useState } from "react";
import Styles from "./style.module.scss";
import RatingForm from './ratingForm';
import Headline4 from '../../compopnents/headings/Headline4';
import ellowLogo from "../../assets/images/ellow-logo.svg";
import { getAssessmentRequestDetails , updateCompanyRatingsfromEmailRedirection } from "./service";
import mixpanelData from "../../utils/mixpanel";


function CustomerRating() {

  let query: any = window.location.href
  let urlParams: any = new URL(query)
  let requestId: any = urlParams.search.slice(11)
 
  const [requestDetails , setRequestDetails] = useState<[]>([])

  const [name , setName] = useState<String>()
  const [candidateRole, setCandidateRole] = useState<String>()
  const [companyName, setCompanyName] = useState<String>()
  const [submitted, setSubmitted] = useState<boolean>()

  useEffect(() => {
    assessmentRequestDetails()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const assessmentRequestDetails = () => {
    getAssessmentRequestDetails(requestId).then((response) => {
        if(response.status === 1){
          if(response.data[0].request_status === "Received"){
            setSubmitted(true)
          }
          if(response.data[0].request_status === "Pending"){
            setSubmitted(false)
          }
          setRequestDetails(response.data[0])
          setName(response.data[0].candidate_name)
          setCandidateRole(response.data[0].candidate_role)
          setCompanyName(response.data[0].company_name)
        }
    })  
  }

  const submitRatings = (data: any) => {
    updateCompanyRatingsfromEmailRedirection(requestId , data).then((response) => {
      if(response && response.status === 1 ){
        setSubmitted(true)
        mixpanelData('MT - Rating submitted', {
          'distinct_id': localStorage.getItem('Email'),
          'Candidate email': response && response.data[0].profile_metadata.email,
          'Candidate id': data.loginId,
          'Company name': data.companyRatings.companyName,
          'Designation': data.companyRatings.designation,
          'Start date': data.companyRatings.startDate && new Date(data.companyRatings.startDate).toDateString(),
          'End date': data.companyRatings.endDate && new Date(data.companyRatings.endDate).toDateString(),
          'Overal rating': data.companyRatings.overAllRating,
          'Productivity rating': data.companyRatings.subRatings.productivity,
          'Communication rating': data.companyRatings.subRatings.communication,
          'Code quality rating': data.companyRatings.subRatings.codeQuality
        })
      }
    })
  }

  return (
    <section className="dashboardWrapper">
      <div className="dashboardContent">
      <div className={Styles.header}>
      <img src={ellowLogo} alt="ellow.io" />
    </div>
        <div className={Styles.certificationCard}>
          {submitted === false &&
            <RatingForm requestId={requestId} requestDetails={requestDetails} clickHandler={submitRatings}/>
          }
          {submitted === true && 
            <div className={Styles.ratingHead}>
              <div className="text-center mt-50">
                <Headline4>Thank you!</Headline4>
                <p>"Thank you for rating <span>"{name}"</span> as <span>"{candidateRole}"</span> at <span>"{companyName}"</span></p>
              </div>
            </div>  
          }
        </div>
      </div>

    </section>
  );
}

export default CustomerRating;
